import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useFavorites } from "../../context/favoritesContext";
import "./medicamentoCard.css";

export default function MedicamentoCard({
  medicamento,
  favoritoId,
  nombre,
  activos,
  precioActual,
  farmacia,
  imagen,
  enlace,
}) {
  const { isFavorite, markFavorite } = useFavorites();

  // Normaliza un objeto "m"
  const m = useMemo(() => {
    if (medicamento) return medicamento;

    return {
      _id: favoritoId,
      nombre,
      sustanciaActiva: activos,
      precioActual,
      precio: precioActual,
      farmacia,
      enlace,
      enlaceImagen: imagen,
    };
  }, [medicamento, favoritoId, nombre, activos, precioActual, farmacia, enlace, imagen]);

  const fav = isFavorite(m?._id);

  // fallback doble para soportar docs viejos y nuevos
  const precioCard = m?.precioActual ?? m?.precio;

  const precioFmt = useMemo(() => {
    if (precioCard == null || Number.isNaN(Number(precioCard))) return "";
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      maximumFractionDigits: 0,
    }).format(Number(precioCard));
  }, [precioCard]);

  const activosTxt = useMemo(() => {
    const a = m?.sustanciaActiva;
    if (!a) return "";
    return Array.isArray(a) ? a.filter(Boolean).join(", ") : String(a);
  }, [m]);

  const farmaciaTxt = useMemo(() => {
    const f = m?.farmacia;
    if (!f) return "";
    return Array.isArray(f) ? f.filter(Boolean).join(", ") : String(f);
  }, [m]);

  return (
    <article className="med-card">
      <button
        type="button"
        className={`med-card__fav ${fav ? "is-fav" : ""}`}
        onClick={() => markFavorite(m)}
        aria-label={fav ? "Quitar de favoritos" : "Agregar a favoritos"}
      >
        ★
      </button>

      <div className="med-card__image-wrap">
        {m?.enlaceImagen ? (
          <img
            src={m.enlaceImagen}
            alt={m?.nombre || "Medicamento"}
            className="med-card__image"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        ) : (
          <div className="med-card__image med-card__image--placeholder">
            Sin imagen
          </div>
        )}
      </div>

      <div className="med-card__body">
        <h3 className="med-card__title">{m?.nombre}</h3>

        {!!farmaciaTxt && <p className="med-card__farmacia">{farmaciaTxt}</p>}

        {!!activosTxt && <p className="med-card__activos">{activosTxt}</p>}

        {precioFmt && <p className="med-card__price">{precioFmt}</p>}

        <Link to={`/detalles/${m?._id}`} className="med-card__link">
          Ver detalles
        </Link>
      </div>
    </article>
  );
}
